/**
 * En-tête d'authentification sûr.
 *
 * ⚠️ Ne JAMAIS construire `Bearer ${localStorage.getItem('token')}` à la main :
 * si le token est absent (module évalué avant le login, course login/logout), on envoie
 * « Bearer null » ou « Bearer  » → le backend répond 401 (« Not enough segments ») et
 * l'intercepteur global déconnecte l'utilisateur en pleine session (bug iter127).
 *
 * Ici, l'en-tête est simplement OMIS quand il n'y a pas de token exploitable :
 * l'intercepteur axios / l'override de window.fetch (App.js) ajoutent alors le bon token.
 */
export const usableToken = () => {
  try {
    const t = localStorage.getItem('token');
    if (!t) return null;
    const v = String(t).trim();
    return v === '' || v === 'null' || v === 'undefined' ? null : v;
  } catch (_) {
    return null;
  }
};

export const authHeaderOrEmpty = () => {
  const t = usableToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export default authHeaderOrEmpty;
